import { getPhotosForPhotowall } from 'entities/photos';

Pixlee.module('Concerns', function(Concerns, App, Backbone, Marionette, $) {
    Concerns.MasonryCollectionView = {
        onShow: function() {
            var _this = this;
            if (this.collection.length === 0) {
                $('#widget_header_table, #photowall_description').css('opacity', '1');
            }
            this.counter = 0;
            if (!gon.v2 && !gon.packery) {
                this.initMasonry();
            }
            if (gon.packery) {
                this.initPackery();
            }
        },
        onRender: function() {
            if (!gon.v2 && !gon.packery) {
                this.initMasonry();
            }

        },
        initPackery: function() {
            var container = this.$el;
            container.packery({
                // options
                itemSelector: '.photo-item-container',
                gutter: 10
            });
            this.referenceCollection = getPhotosForPhotowall();
            this.image_count = 0;
            this.moreimages = [];
            gon.fresh_images = [];
            this.child_views = [];
            this.$el.css('width', '100%');
            this.$el.addClass('mosiac');
        },
        changeRandomImage: function() {
            var _this = this;
            if (gon.fresh_images.length == 0 && !this.syncing) {
                this.referenceCollection.reset();
                this.referenceCollection.models = [];
                if (!_this.referenceCollection.next) {
                    gon.currentLength = 0;
                    this.referenceCollection.goTo(1);
                    this.syncing = true;
                } else {
                    this.referenceCollection.nextPage({
                        remove: false
                    });
                    this.syncing = true;
                }
                _this.changeRandomImage();
            } else if (gon.fresh_images.length > 0) {
                this.syncing = false;
                var random = Math.floor(Math.random() * this.child_views.length);
                if (!gon.lightBoxOpen) {
                    this.child_views[random].changeImage();
                }
                var _this = this;
                setTimeout(function() {
                    _this.changeRandomImage();
                }, 5000);
            } else {
                setTimeout(function() {
                    if (_this.moreimages.length > 0) {
                        _.each(_this.moreimages, function(model) {
                            if (model.attributes && model.attributes.source_url) {
                                gon.fresh_images.push(model);
                            }
                        });
                        _this.moreimages = [];
                    }
                    _this.referenceCollection.each(function(model) {
                        if (model.attributes && model.attributes.source_url) {
                            gon.fresh_images.push(model);
                        }
                    });
                    _this.changeRandomImage();
                }, 5000);
            }

        },
        onAddChild: function(childView) {
            var _this = this;
            childView.$el.find('.box').css('margin-bottom', $('.gutter').width());
            if (childView.$el.attr('id') != 'empty_photowall') {

                $('#widget_header_table,#photowall_description').css('opacity', '1');
                if (typeof gon.widget != 'undefined') {
                    if (!_this.loaded) {
                        _this.removeLoader();
                    }
                }
                childView.$el.css({
                    opacity: 1
                });
                var imageHolder = $(childView.$el).find('.lightboxed');
                var photoblock = $(childView.$el).find('.photo_block, .img_holder');
                var bottom = $(childView.$el).find('svg, .image_info');

                if (gon.v2 && !gon.isMobileDevice && !gon.packery) {

                    photoblock.css({
                        height: _this.getPhotoSize(),
                        width: _this.getPhotoSize()
                    });
                    imageHolder.css({
                        height: _this.getPhotoSize(),
                        width: _this.getPhotoSize()
                    });
                    bottom.css({
                        width: _this.getPhotoSize()
                    });
                } else if (gon.packery && !gon.isMobileDevice) {
                    if (this.image_count < 16) {
                        var size = _this.randomPhotoSize() + 'px';
                        photoblock.css({
                            height: size,
                            width: size
                        });
                        imageHolder.css({
                            height: size,
                            width: size
                        });
                        bottom.remove();
                        childView.$el.find('.social_holder, .vote_button').remove();
                        childView.$el.css({
                            height: size,
                            width: size
                        });
                        this.$el.packery('appended', childView.$el);
                        this.$el.find('.img_holder').cycle({
                            speed: 500,
                            timeout: 0
                        });
                        this.child_views.push(childView);
                        this.image_count++;
                    } else {
                        var model = childView.model;
                        this.moreimages.push(model);
                        childView.model.collection.remove(childView.model);
                        this.image_count++;
                        childView.remove();

                    }

                } else if (!gon.v2) {
                    $(childView.$el).find('.layer_share').css({
                        height: _this.getPhotoSize(),
                        width: _this.getPhotoSize(),
                        top: 0
                    });
                    $(childView.$el).find('.box_bg_image').css({
                        height: _this.getPhotoSize(),
                        width: _this.getPhotoSize()
                    });
                    _this.$el.masonry('appended', childView.$el);
                }
                _this.trigger('images:loaded');


            } else {
                childView.$el.css({
                    opacity: 1
                });
            }
        },
        onBeforeAddChild: function(childView) {
            if (typeof gon.widget != 'undefined') {
                if (!this.initLoader) {
                    this.showLoader();
                }
            }
            childView.$el.css({
                opacity: 0
            });
        },
        randomPhotoSize: function() {
            if (this.counter == 0) {
                this.counter++;
                return 350;
            } else {
                if (this.counter == 2) {
                    this.counter = 0;
                } else {
                    this.counter++;
                }
                return 170;
            }
        },
        onRemoveChild: function(childView) {
            if (gon.packery) {
                return false;
            }
            this.$el.masonry('remove', $(childView));
            this.$el.masonry({
                itemSelector: '.box',
                gutter: $('.gutter').width(),
                isFitWidth: true,
                isAnimatedFromBottom: true
            });
        },
        onDestroy: function() {
            this.destroyMasonry();
        },
        destroyMasonry: function() {
            this.$el.masonry('destroy');
        },
        initMasonry: function() {
            this.$el.masonry(this.getDefaultsMasonryOptions());
        },
        getPhotoSize: function() {
            if (gon.v2) {
                if (gon.display_options && gon.display_options.photoSize === 'small_photo') {
                    return '150px';
                } else if (gon.display_options && gon.display_options.photoSize === 'medium_photo') {
                    return '200px';
                } else if (gon.display_options) {
                    return '260px';
                }
            } else {
                if (gon.display_options && gon.display_options.photoSize === 'small_photo') {
                    return '150px';
                } else if (gon.display_options && gon.display_options.photoSize === 'medium_photo') {
                    return '200px';
                } else if (gon.display_options) {
                    return '240px';
                }
            }
        },
        getDefaultsMasonryOptions: function() {
            var columnWidth;
            if (gon.display_options && gon.display_options.photoSize === 'small_photo') {
                columnWidth = 150;
            } else if (gon.display_options && gon.display_options.photoSize === 'medium_photo') {
                columnWidth = 200;
            } else if (gon.display_options) {
                columnWidth = 240;
            } else {
                columnWidth = 227;
            }
            var transitionDuration;
            if (gon.isMobileDevice) {
                transitionDuration = 0;
            } else {
                transitionDuration = '0';
            }
            return {
                itemSelector: (gon.v2) ? '.photo_block' : '.box',
                gutter: $('.gutter').width(),
                isFitWidth: true,
                isAnimatedFromBottom: true,
                transitionDuration: transitionDuration
            };
        }
    };

});
